export default "__VITE_ASSET__DNq7D56n__"